// src/serviceWorker.js
// CRA leftover — the app never registers a service worker. This only tears down
// any SW a visitor's browser cached from a past setup, so stale assets don't serve.
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
}
